export default __webpack_public_path__ + "static/media/fixture2_footer.6e3b662d.png";